require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ../~/_core-js@2.6.9@core-js/library/fn/object/assign.js
// module id = 1000
// module chunks = 0